const list = () => {
    const $parent = $(".services .service-list")
    $parent.on("mouseenter", ".service-item", function () {
        $parent.find(".service-item.active").removeClass("active");
        $(this).addClass("active")
    })
}

module.exports = list